module.exports = __webpack_public_path__ + "img/icon_menu_sp_syukaku.400be143.png";